/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @nx/enforce-module-boundaries */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo } from 'react';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import route from '../../../../../assets/icons/route.svg';
import clock from '../../../../../assets/icons/Clock.svg';
import deviation from '../../../../../assets/icons/Deviation.svg';
import check from '../../../../../assets/icons/check.svg';
import infoIcon from '../../../../../assets/icons/i.svg';
import { API_ENDPOINTS } from 'packages/novous_web/src/api/endpoints';
import useAxios from 'packages/novous_web/src/api/useAxios';
import {
  convertMinutesToFormattedTime,
  formatDistancePerDay,
  formatTimePerDay,
} from 'packages/novous_web/src/utils/helper';
import { ReactComponent as RouteIcon } from 'packages/novous_web/src/assets/icons/under_coaching.svg';
import { ReactComponent as CheckIcon } from 'packages/novous_web/src/assets/icons/coaching_completed.svg';
import { ReactComponent as AverageAlert } from 'packages/novous_web/src/assets/icons/average_alert.svg';
import ClockIcon from 'packages/novous_web/src/iconComponent/clockIcon';
import DeviationIcon from 'packages/novous_web/src/iconComponent/DeviationIcon';
import { title } from 'process';
import { IconButton, Tooltip } from '@mui/material';
import { useAuth } from 'packages/novous_web/src/authContext/useAuth';
import { BorderAll } from '@mui/icons-material';
import PermissionGuard from '../../../../../common/components/PermissionGuard';
import { PermissionCategory, PermissionSubcategory } from '../../../../../utils/permissionConstants';

interface DriverCoachingTilesResponse {
  data: {
    averageAlertPerDriver: number;
    coachingCompleted: number;
    coachingRequired: number;
    underCoaching: number;
  };
}

type ColumnObjType = {
  [key: string]: {
    name: string;
    status: boolean;
  };
};

const DriverCoachingDataTiles: React.FC<{
  driverCoachingTilesData: any;
  tilesObj?: { [key: string]: { name: string; status: boolean; selected?: string } };
}> = ({ driverCoachingTilesData, tilesObj }) => {
  const { user } = useAuth();
  // const {
  //     data: driverCoachingTilesData,
  //     error: driverCoachingTilesError,
  //     loading: driverCoachingTilesLoading,
  //     fetchData: fetchDriverCoachingTilesData,
  // } = useAxios<DriverCoachingTilesResponse>(API_ENDPOINTS.coaching.DRIVER_COACHING_TILES, "POST"
  // );

  // useEffect(() => {
  //     fetchDriverCoachingTilesData({
  //         fleetId: user?.customer_id,
  //     });
  // }, [])

  const tripTilesData = useMemo(() => {
    if (!driverCoachingTilesData?.data) return [];

    const base = [
      {
        icon: <RouteIcon />,
        heading: 'Under Coaching',
        description: 'Drivers currently undergoing coaching',
        value: driverCoachingTilesData.data.underCoaching,
        permission: {
          category: PermissionCategory.DRIVER_COACHING,
          subcategory: PermissionSubcategory.UNDER_COACHING,
        },
      },
      {
        icon: <RouteIcon />,
        heading: 'Coaching Required',
        description: 'Drivers needing coaching',
        value: driverCoachingTilesData.data.coachingRequired,
        permission: {
          category: PermissionCategory.DRIVER_COACHING,
          subcategory: PermissionSubcategory.COACHING_REQUIRED,
        },
      },
      {
        icon: <CheckIcon />,
        heading: 'Coaching Completed',
        description: 'Drivers who completed coaching',
        value: driverCoachingTilesData.data.coachingCompleted,
        permission: {
          category: PermissionCategory.DRIVER_COACHING,
          subcategory: PermissionSubcategory.COACHING_COMPLETED,
        },
      },
      {
        icon: <AverageAlert />,
        heading: 'Average Alerts per Driver',
        description: 'Average alerts per driver',
        value: driverCoachingTilesData.data.averageAlertPerDriver,
        permission: {
          category: PermissionCategory.DRIVER_COACHING,
          subcategory: PermissionSubcategory.AVERAGE_ALERTS_PER_DRIVER,
        },
      },
    ];

    // If a tilesObj is provided, it controls visibility (status) and can override names.
    const tileKeys = ['Stat1', 'Stat2', 'Stat3', 'Stat4'];

    return base.map((item, idx) => {
      const key = tileKeys[idx];
      const override = tilesObj && tilesObj[key];
      return {
        ...item,
        heading: override && override.name ? override.name : item.heading,
        visible: override ? !!override.status : true,
      };
    });
  }, [driverCoachingTilesData, tilesObj]);

  return (
    <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {tripTilesData
        .filter((t: any) => t.visible)
        .map((tile: any, index: number) => (
          <PermissionGuard
            key={index}
            category={tile.permission.category}
            subcategory={tile.permission.subcategory}
          >
            <Paper
              sx={{ borderRadius: '12px' }}
              className="border border-[#f0eff8] p-4 flex flex-col gap-1 items-start"
            >
              <div className="flex items-center gap-2 w-full">
                <IconButton
                  sx={(theme) => ({
                    background: theme.palette.selected,
                    padding: '4px',
                    borderRadius: '8px',
                  })}
                >
                  {tile?.icon}
                  {/* <img src={tile?.icon} alt="icon" color="primary" /> */}
                </IconButton>
                <div className="flex flex-1 min-w-0 flex-col justify-start gap-1">
                  <Typography
                    variant="body2"
                    noWrap // Ensures text doesn't wrap and remains in a single line
                    sx={{
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      maxWidth: '100%', // Ensures it adapts to available space
                    }}
                  >
                    {tile.heading}
                  </Typography>
                </div>

                <Tooltip title={tile.description}>
                  <img src={infoIcon} alt="info icon" className="w-4 h-4 cursor-pointer" />
                </Tooltip>
              </div>
              <div className="flex items-center w-full gap-2 flex-nowrap">
                <div className="invisible w-6 h-6">{tile.icon}</div>
                <Typography
                  variant="h6"
                  fontWeight={600}
                  className="flex-grow px-2 w-full whitespace-nowrap overflow-hidden text-ellipsis"
                >
                  {tile.value}
                </Typography>
              </div>
            </Paper>
          </PermissionGuard>
        ))}
    </div>
  );
};

export default DriverCoachingDataTiles;
